// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../../stores/mobx-compat";

import Input from '../../../../ui/Input';
import IconButton from '../../../../ui/IconButton';
import { SearchIcon } from '../../../../ui/icons';

class TypeformSearch extends Component {
  typeform = this.props.store.integrations.Typeform;

  render() {
    const { loading } = this.typeform;
    return (
      <div className="flex items-center gap-2">
        <Input
          placeholder="Search forms by name…"
          onChange={(e) => this.typeform.updateSearch(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') this.typeform.handleSearch(); }}
          style={{ minWidth: 260 }}
        />
        <IconButton
          variant="filled"
          icon={SearchIcon}
          ariaLabel="Search"
          onClick={() => this.typeform.handleSearch()}
          disabled={loading.retrieveForms}
        />
      </div>
    );
  }
}

export default inject('store')(observer(TypeformSearch));
